module.exports = __webpack_public_path__ + "assets/image.33a57f38.svg";